<main *ngIf="loginRole === 'superadmin' || loginRole === 'csqadmin'">
  <div class="d-grid gap-3">
    <!-- Header Section -->
    <div
      class="d-flex justify-content-between align-items-center width-class w-100 flex-wrap gap-3"
    >
      <div
        class="d-flex gap-3 align-items-center"
        style="cursor: pointer"
        (click)="!pageloading && goBack()"
      >
        <img
          class="action-button"
          [class.skeleton-img]="pageloading"
          src="../../../../../assets/images/Buttons/arrow-left.svg"
          alt="left"
        />
        <div class="header-text m-0" [class.skeleton-text]="pageloading">
          Back to event list
        </div>
      </div>
      <button
        class="copy-button compact-copy-button"
        [disabled]="pageloading"
        (click)="openCopyLink()"
        *ngIf="
          eventData?.eventStatus === 'Upcoming' ||
          eventData?.eventStatus === 'Ongoing' ||
          eventData?.eventStatus === 'Already Held'
        "
      >
        <img
          class="btn-icon"
          [class.skeleton-img]="pageloading"
          src="../../../../../assets/images/link-angled.svg"
          alt="left"
        />
        <span [class.skeleton-text]="pageloading">Copy event link</span>
        <!-- <img class="action-button" [class.skeleton-img]="pageloading" 
             src="../../../../../assets/images/chevron-down.svg" alt="left" /> -->
      </button>
    </div>

    <!-- Event Details Card -->
    <div class="event-card">
      <!-- Skeleton Image -->
      <div class="event-image-container">
        <img
          class="event-image"
          [class.skeleton-img]="pageloading"
          [src]="
            pageloading
              ? 'assets/images/placeholder-image.svg'
              : eventData?.eventTypeImage ||
                'assets/images/placeholder-image.svg'
          "
          [alt]="eventData?.eventTypeName"
        />
      </div>

      <div class="w-100 d-grid gap-3 align-items-baseline">
        <!-- Header with Event Name and Actions -->
        <div
          class="d-flex w-100 justify-content-between align-items-center flex-wrap gap-2"
        >
          <div class="d-flex gap-2 align-items-center flex-wrap">
            <span class="event-name" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.eventName || "Event Name"
              }}
            </span>
            <div
              class="publish-tag"
              *ngIf="!pageloading && eventData?.isDraft === false"
            >
              Published
            </div>
          </div>

          <div class="event-card-side-actions" *ngIf="!pageloading">
            <div class="d-grid gap-2 status-text">
              Event status
              <div class="status-dropdown-container">
                <div
                  class="status-display"
                  [ngClass]="getStatusClass(eventData?.eventStatus)"
                  [style.cursor]="
                    canChangeEventStatus() ? 'pointer' : 'default'
                  "
                  (click)="
                    canChangeEventStatus() && toggleStatusDropdown($event)
                  "
                >
                  {{ getStatusDisplayValue(eventData?.eventStatus) }}
                  <img
                    *ngIf="canChangeEventStatus()"
                    src="assets/images/Buttons/arrow.svg"
                    class="dropdown-arrow"
                    [class.rotated]="showStatusDropdown"
                    alt="dropdown arrow"
                  />
                </div>
                <div class="status-skeleton" *ngIf="pageloading"></div>

                <div
                  class="status-dropdown-menu"
                  [class.show]="showStatusDropdown"
                  (click)="$event.stopPropagation()"
                >
                  <ng-container
                    *ngIf="statusOptions.length > 0; else loadingStatus"
                  >
                    <div
                      *ngFor="let status of statusOptions"
                      class="status-option"
                      (click)="updateEventStatus(status)"
                    >
                      {{ status.label }}
                    </div>
                  </ng-container>
                  <ng-template #loadingStatus>
                    <div class="status-option loading">Loading...</div>
                  </ng-template>
                </div>

                <div
                  class="status-backdrop"
                  *ngIf="showStatusDropdown"
                  (click)="closeStatusDropdown()"
                ></div>
              </div>
            </div>

            <div *ngIf="canEditCurrentEvent()">
              <div
                class="blue-text"
                (click)="!pageloading && onEdit(eventData)"
                style="cursor: pointer"
              >
                <img
                  class="action-button"
                  [class.skeleton-img]="pageloading"
                  src="assets/images/Buttons/edit-button.svg"
                  alt="Edit"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Event Details Grid -->
        <div class="details-layout">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Event type
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.eventTypeName || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Start date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventStartDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              End date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventEndDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Time
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.eventTime || "-" }}
            </div>
          </div>
        </div>

        <!-- Location -->
        <div class="d-grid gap-2">
          <div class="primary-text" [class.skeleton-text]="pageloading">
            Location
          </div>
          <div class="secondary-text" [class.skeleton-text]="pageloading">
            {{ pageloading ? "Loading..." : eventData?.location || "-" }}
          </div>
        </div>
      </div>

      <div class="event-feedback-overlay">
        <button
          *ngIf="isFeedbackVisible()"
          class="feedback-button"
          [disabled]="pageloading || isFeedbackButtonDisabled()"
          (click)="addFeedBack('41rem')"
        >
          <img
            class="btn-icon"
            [class.skeleton-img]="pageloading"
            src="../../../../../assets/images/message-text.svg"
            alt="feedback"
          />
          <span [class.skeleton-text]="pageloading">{{
            getFeedbackButtonLabel()
          }}</span>
        </button>
      </div>
    </div>

    <!-- Metrics and Chart Section -->
    <div class="chart-layout">
      <!-- Left Column -->
      <div class="d-flex gap-3 flex-column w-100">
        <div class="d-flex justify-content-between gap-2 three-items-container">
          <div class="total-card" [class.total-card-active]="true">
            <span class="secondary-text" [class.skeleton-text]="pageloading"
              >Total registrations</span
            >
            <span class="primary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading ? "---" : engagementMetrics?.totalRegistrations || 0
              }}
            </span>
          </div>

          <div class="total-card">
            <span class="secondary-text" [class.skeleton-text]="pageloading"
              >Total attendees</span
            >
            <span class="primary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "---" : engagementMetrics?.totalAttendees || 0 }}
            </span>
          </div>

          <div class="total-card">
            <span class="secondary-text" [class.skeleton-text]="pageloading"
              >Conversion</span
            >
            <span class="primary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "---"
                  : (engagementMetrics?.conversionRate || 0) + "%"
              }}
            </span>
          </div>
        </div>

        <!-- Event Details Card -->
        <div class="chart-details-card">
          <div class="d-grid gap-3 w-100">
            <div class="d-flex gap-2 align-items-start secondary-text">
              <span class="fw-normal" [class.skeleton-text]="pageloading"
                >Focus area :</span
              >
              <span class="primary-text" [class.skeleton-text]="pageloading">
                {{ pageloading ? "Loading..." : getFocusAreaNames() }}
              </span>
            </div>
            <div class="d-flex gap-2 align-items-start secondary-text">
              <span class="fw-normal" [class.skeleton-text]="pageloading"
                >Audience :</span
              >
              <span class="primary-text" [class.skeleton-text]="pageloading">
                {{
                  pageloading
                    ? "Loading..."
                    : eventData?.audienceTypeName || "-"
                }}
              </span>
            </div>
            <div class="d-flex gap-2 align-items-start secondary-text">
              <span class="fw-normal" [class.skeleton-text]="pageloading"
                >Region :</span
              >
              <span class="primary-text" [class.skeleton-text]="pageloading">
                {{
                  pageloading
                    ? "Loading..."
                    : eventData?.eventHostRegionName || "-"
                }}
              </span>
            </div>
            <div class="d-flex gap-2 align-items-start secondary-text">
              <span class="fw-normal" [class.skeleton-text]="pageloading"
                >Event managers :</span
              >
              <span class="primary-text" [class.skeleton-text]="pageloading">
                {{ pageloading ? "Loading..." : getManagersNames() }}
              </span>
            </div>
            <div class="d-flex gap-2 align-items-start secondary-text">
              <span class="fw-normal" [class.skeleton-text]="pageloading"
                >Industry Partners :</span
              >
              <span class="primary-text" [class.skeleton-text]="pageloading">
                {{ pageloading ? "Loading..." : getMCCpartnersNames() }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column - Chart -->
      <div>
        <div class="chart-wrapper">
          <h3 class="chart-title" [class.skeleton-text]="pageloading">
            Attendance success rate
          </h3>
          <div *ngIf="!chartLoading && !pageloading; else chartLoadingTemplate">
            <div
              *ngIf="chartData; else noChartData"
              #chartContainer
              class="chart-container"
            ></div>
          </div>

          <!-- Templates -->
          <ng-template #noChartData>
            <div class="no-data-message">
              <p [class.skeleton-text]="pageloading">
                No registration data available for this event
              </p>
            </div>
          </ng-template>

          <ng-template #chartLoadingTemplate>
            <div class="no-data-message">
              <p [class.skeleton-text]="pageloading">
                {{
                  pageloading
                    ? "Loading event data..."
                    : "Loading chart data..."
                }}
              </p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Students Table Section -->
    <div class="table-details">
      <div class="settings-bg">
        <div
          class="d-flex justify-content-between settings-bg-button flex-wrap"
        >
          <div class="segment-buttons">
            <div [class.skeleton-text]="pageloading">Students</div>
          </div>
          <div class="add-buttons" *ngIf="!eventData?.isDraft">
            <button
              class="export-csv-button"
              (click)="exportStudentsToCSV()"
              [disabled]="pageloading || !eventStudentList.length"
            >
              <img
                src="assets/images/download-icon.svg"
                alt="export"
                class="plus-icon"
                [class.skeleton-img]="pageloading"
              />
              <span [class.skeleton-text]="pageloading">Export</span>
            </button>
            <button
              *ngIf="canEditCurrentEvent()"
              (click)="openAssignStudentsDialog()"
              [disabled]="pageloading || studentTabelLoading"
            >
              <img
                src="assets/images/add-icon.svg"
                alt="plus"
                class="plus-icon"
                [class.skeleton-img]="pageloading"
              />
              <span [class.skeleton-text]="pageloading">Assign student</span>
            </button>
          </div>
        </div>

        <div class="table-page">
          <app-custom-reg-table
            [columns]="adminStudentColumn"
            [data]="eventStudentList"
            [loading]="studentTabelLoading || pageloading"
            [eventStatus]="eventData?.eventStatus"
            [allowEventStatusChange]="loginRole === 'superadmin'"
            [loginRole]="loginRole"
            (eventStatusChange)="onAdminEventStatusChange($event)"
            (toggleChange)="onToggleChange($event)"
            (downloadClick)="onDownloadConsent($event)"
            (noteUpdate)="onNoteUpdate($event)"
            (mediaConsentToggle)="onMediaConsentToggle($event)"
          >
          </app-custom-reg-table>
        </div>
      </div>
    </div>
  </div>
</main>

<main *ngIf="loginRole === 'csquser'">
  <div class="d-grid gap-3">
    <!-- Header Section -->
    <div
      class="d-flex justify-content-between align-items-center width-class w-100 flex-wrap gap-3"
    >
      <div
        class="d-flex gap-3 align-items-center"
        style="cursor: pointer"
        (click)="!pageloading && goBack()"
      >
        <img
          class="action-button"
          [class.skeleton-img]="pageloading"
          src="../../../../../assets/images/Buttons/arrow-left.svg"
          alt="left"
        />
        <div class="header-text m-0" [class.skeleton-text]="pageloading">
          Back to event list
        </div>
      </div>
      <button
        class="copy-button compact-copy-button"
        [disabled]="pageloading"
        (click)="openCopyLink()"
        *ngIf="
          eventData?.eventStatus === 'Upcoming' ||
          eventData?.eventStatus === 'Ongoing' ||
          eventData?.eventStatus === 'Already Held'
        "
      >
        <img
          class="btn-icon"
          [class.skeleton-img]="pageloading"
          src="../../../../../assets/images/link-angled.svg"
          alt="left"
        />
        <span [class.skeleton-text]="pageloading">Copy event link</span>
        <!-- <img class="action-button" [class.skeleton-img]="pageloading"
             src="../../../../../assets/images/chevron-down.svg" alt="left" /> -->
      </button>
    </div>

    <!-- Event Details Card -->
    <div class="event-card">
      <!-- Skeleton Image -->
      <div class="event-image-container">
        <img
          class="event-image"
          [class.skeleton-img]="pageloading"
          [src]="
            pageloading
              ? 'assets/images/placeholder-image.svg'
              : eventData?.eventTypeImage ||
                'assets/images/placeholder-image.svg'
          "
          [alt]="eventData?.eventTypeName"
        />
      </div>

      <div class="w-100 d-grid gap-3 align-items-baseline">
        <!-- Header with Event Name and Actions -->
        <div
          class="d-flex w-100 justify-content-between align-items-center flex-wrap gap-2"
        >
          <div class="d-flex gap-2 align-items-center flex-wrap">
            <span class="event-name" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.eventName || "Event Name"
              }}
            </span>
            <div
              class="publish-tag"
              *ngIf="!pageloading && eventData?.isDraft === false"
            >
              Published
            </div>
          </div>

          <div class="event-card-side-actions" *ngIf="!pageloading">
            <div class="d-grid gap-2 status-text">
              Event status
              <div class="status-dropdown-container">
                <div
                  class="status-display"
                  [ngClass]="getStatusClass(eventData?.eventStatus)"
                  [style.cursor]="
                    canChangeEventStatus() ? 'pointer' : 'default'
                  "
                  (click)="
                    canChangeEventStatus() && toggleStatusDropdown($event)
                  "
                >
                  {{ getStatusDisplayValue(eventData?.eventStatus) }}
                  <img
                    *ngIf="canChangeEventStatus()"
                    src="assets/images/Buttons/arrow.svg"
                    class="dropdown-arrow"
                    [class.rotated]="showStatusDropdown"
                    alt="dropdown arrow"
                  />
                </div>
                <div class="status-skeleton" *ngIf="pageloading"></div>

                <div
                  class="status-dropdown-menu"
                  [class.show]="showStatusDropdown"
                  (click)="$event.stopPropagation()"
                >
                  <ng-container
                    *ngIf="statusOptions.length > 0; else loadingStatus"
                  >
                    <div
                      *ngFor="let status of statusOptions"
                      class="status-option"
                      (click)="updateEventStatus(status)"
                    >
                      {{ status.label }}
                    </div>
                  </ng-container>
                  <ng-template #loadingStatus>
                    <div class="status-option loading">Loading...</div>
                  </ng-template>
                </div>

                <div
                  class="status-backdrop"
                  *ngIf="showStatusDropdown"
                  (click)="closeStatusDropdown()"
                ></div>
              </div>
            </div>

            <div *ngIf="canEditCurrentEvent()">
              <div
                class="blue-text"
                (click)="!pageloading && onEdit(eventData)"
                style="cursor: pointer"
              >
                <img
                  class="action-button"
                  [class.skeleton-img]="pageloading"
                  src="assets/images/Buttons/edit-button.svg"
                  alt="Edit"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Event Details Grid -->
        <div class="details-layout">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Event type
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.eventTypeName || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Start date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventStartDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              End date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventEndDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Time
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.eventTime || "-" }}
            </div>
          </div>
        </div>

        <!-- Location -->
        <div class="d-grid gap-2">
          <div class="primary-text" [class.skeleton-text]="pageloading">
            Location
          </div>
          <div class="secondary-text" [class.skeleton-text]="pageloading">
            {{ pageloading ? "Loading..." : eventData?.location || "-" }}
          </div>
        </div>
      </div>

      <div class="event-feedback-overlay">
        <button
          *ngIf="isFeedbackVisible()"
          class="feedback-button"
          [disabled]="pageloading || isFeedbackButtonDisabled()"
          (click)="addFeedBack('41rem')"
        >
          <img
            class="btn-icon"
            [class.skeleton-img]="pageloading"
            src="../../../../../assets/images/message-text.svg"
            alt="feedback"
          />
          <span [class.skeleton-text]="pageloading">{{
            getFeedbackButtonLabel()
          }}</span>
        </button>
      </div>
    </div>

    <!-- Metrics and Chart Section -->
    <div class="chart-layout">
      <!-- Left Column -->
      <div class="d-flex gap-3 flex-column w-100">
        <div class="d-flex justify-content-between gap-2 three-items-container">
          <div class="total-card" [class.total-card-active]="true">
            <span class="secondary-text" [class.skeleton-text]="pageloading"
              >Total registrations</span
            >
            <span class="primary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading ? "---" : engagementMetrics?.totalRegistrations || 0
              }}
            </span>
          </div>

          <div class="total-card">
            <span class="secondary-text" [class.skeleton-text]="pageloading"
              >Total attendees</span
            >
            <span class="primary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "---" : engagementMetrics?.totalAttendees || 0 }}
            </span>
          </div>

          <div class="total-card">
            <span class="secondary-text" [class.skeleton-text]="pageloading"
              >Conversion</span
            >
            <span class="primary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "---"
                  : (engagementMetrics?.conversionRate || 0) + "%"
              }}
            </span>
          </div>
        </div>

        <!-- Event Details Card -->
        <div class="chart-details-card">
          <div class="d-grid gap-3 w-100">
            <div class="d-flex gap-2 align-items-start secondary-text">
              <span class="fw-normal" [class.skeleton-text]="pageloading"
                >Focus area :</span
              >
              <span class="primary-text" [class.skeleton-text]="pageloading">
                {{ pageloading ? "Loading..." : getFocusAreaNames() }}
              </span>
            </div>
            <div class="d-flex gap-2 align-items-start secondary-text">
              <span class="fw-normal" [class.skeleton-text]="pageloading"
                >Audience :</span
              >
              <span class="primary-text" [class.skeleton-text]="pageloading">
                {{
                  pageloading
                    ? "Loading..."
                    : eventData?.audienceTypeName || "-"
                }}
              </span>
            </div>
            <div class="d-flex gap-2 align-items-start secondary-text">
              <span class="fw-normal" [class.skeleton-text]="pageloading"
                >Region :</span
              >
              <span class="primary-text" [class.skeleton-text]="pageloading">
                {{
                  pageloading
                    ? "Loading..."
                    : eventData?.eventHostRegionName || "-"
                }}
              </span>
            </div>
            <div class="d-flex gap-2 align-items-start secondary-text">
              <span class="fw-normal" [class.skeleton-text]="pageloading"
                >Event managers :</span
              >
              <span class="primary-text" [class.skeleton-text]="pageloading">
                {{ pageloading ? "Loading..." : getManagersNames() }}
              </span>
            </div>
            <div class="d-flex gap-2 align-items-start secondary-text">
              <span class="fw-normal" [class.skeleton-text]="pageloading"
                >Industry Partners :</span
              >
              <span class="primary-text" [class.skeleton-text]="pageloading">
                {{ pageloading ? "Loading..." : getMCCpartnersNames() }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column - Chart -->
      <div>
        <div class="chart-wrapper">
          <h3 class="chart-title" [class.skeleton-text]="pageloading">
            Registration over time
          </h3>
          <div *ngIf="!chartLoading && !pageloading; else chartLoadingTemplate">
            <div
              *ngIf="chartData; else noChartData"
              #chartContainer
              class="chart-container"
            ></div>
          </div>

          <!-- Templates -->
          <ng-template #noChartData>
            <div class="no-data-message">
              <p [class.skeleton-text]="pageloading">
                No registration data available for this event
              </p>
            </div>
          </ng-template>

          <ng-template #chartLoadingTemplate>
            <div class="no-data-message">
              <p [class.skeleton-text]="pageloading">
                {{
                  pageloading
                    ? "Loading event data..."
                    : "Loading chart data..."
                }}
              </p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Students Table Section -->
    <div class="table-details">
      <div class="settings-bg">
        <div
          class="d-flex justify-content-between settings-bg-button flex-wrap"
        >
          <div class="segment-buttons">
            <div [class.skeleton-text]="pageloading">Students</div>
          </div>
          <div class="add-buttons" *ngIf="!eventData?.isDraft">
            <button
              class="export-csv-button"
              (click)="exportStudentsToCSV()"
              [disabled]="pageloading || !eventStudentList.length"
            >
              <img
                src="assets/images/download-icon.svg"
                alt="export"
                class="plus-icon"
                [class.skeleton-img]="pageloading"
              />
              <span [class.skeleton-text]="pageloading">Export</span>
            </button>
            <button
              *ngIf="canEditCurrentEvent()"
              (click)="openAssignStudentsDialog()"
              [disabled]="pageloading || studentTabelLoading"
            >
              <img
                src="assets/images/add-icon.svg"
                alt="plus"
                class="plus-icon"
                [class.skeleton-img]="pageloading"
              />
              <span [class.skeleton-text]="pageloading">Assign student</span>
            </button>
          </div>
        </div>

        <div class="table-page">
          <app-custom-reg-table
            [columns]="adminStudentColumn"
            [data]="eventStudentList"
            [loading]="studentTabelLoading || pageloading"
            [eventStatus]="eventData?.eventStatus"
            [allowEventStatusChange]="loginRole === 'superadmin'"
            [loginRole]="loginRole"
            (eventStatusChange)="onAdminEventStatusChange($event)"
            (toggleChange)="onToggleChange($event)"
            (downloadClick)="onDownloadConsent($event)"
            (noteUpdate)="onNoteUpdate($event)"
            (mediaConsentToggle)="onMediaConsentToggle($event)"
          >
          </app-custom-reg-table>
        </div>
      </div>
    </div>
  </div>
</main>

<main *ngIf="loginRole === 'teacher' && !isUnauthorised">
  <div class="d-grid gap-3">
    <!-- Header Section -->
    <div
      class="d-flex justify-content-between align-items-center width-class w-100 flex-wrap gap-3"
    >
      <div
        class="d-flex gap-3 align-items-center"
        style="cursor: pointer"
        (click)="!pageloading && goBack()"
      >
        <img
          class="action-button"
          [class.skeleton-img]="pageloading"
          src="../../../../../assets/images/Buttons/arrow-left.svg"
          alt="left"
        />
        <div class="header-text m-0" [class.skeleton-text]="pageloading">
          Back to event list
        </div>
      </div>
      <button
        class="copy-button compact-copy-button"
        [disabled]="pageloading"
        (click)="openCopyLink()"
        *ngIf="
          eventData?.eventStatus === 'Upcoming' ||
          eventData?.eventStatus === 'Ongoing' ||
          eventData?.eventStatus === 'Already Held'
        "
      >
        <img
          class="btn-icon"
          [class.skeleton-img]="pageloading"
          src="../../../../../assets/images/link-angled.svg"
          alt="left"
        />
        <span [class.skeleton-text]="pageloading">Copy event link</span>
        <!-- <img class="action-button" [class.skeleton-img]="pageloading" 
             src="../../../../../assets/images/chevron-down.svg" alt="left" /> -->
      </button>
    </div>

    <!-- Event Details Card -->
    <div class="event-card">
      <div class="event-image-container">
        <img
          class="event-image"
          [class.skeleton-img]="pageloading"
          [src]="
            pageloading
              ? 'assets/images/placeholder-image.svg'
              : eventData?.eventTypeImage ||
                'assets/images/placeholder-image.svg'
          "
          [alt]="eventData?.eventTypeName"
        />
      </div>

      <div class="w-100 d-grid gap-3 align-items-baseline">
        <div>
          <div
            class="d-flex w-100 justify-content-between align-items-center flex-wrap gap-2"
          >
            <div class="d-flex gap-2 align-items-center flex-wrap">
              <span class="event-name" [class.skeleton-text]="pageloading">
                {{
                  pageloading
                    ? "Loading..."
                    : eventData?.eventName || "Event Name"
                }}
              </span>
              <div
                class="publish-tag"
                *ngIf="!pageloading && eventData?.isDraft === false"
              >
                Published
              </div>
            </div>
          </div>
          <div class="des-text" [class.skeleton-text]="pageloading">
            {{
              pageloading
                ? "Loading..."
                : eventData?.eventTypeImageDescription || ""
            }}
          </div>
        </div>

        <!-- Event Details Grid -->
        <div class="details-layout-teacher">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Event type
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.eventTypeName || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Start date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventStartDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              End date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventEndDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
        </div>

        <div class="details-layout-teacher">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Time
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.eventTime || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Location
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.location || "-" }}
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex gap-4 align-items-start">
        <div class="d-grid gap-2 status-text" *ngIf="!pageloading">
          Event status
          <div class="status-dropdown-container">
            <div
              class="status-display"
              [ngClass]="getStatusClass(eventData?.eventStatus)"
              style="cursor: default"
            >
              {{ getStatusDisplayValue(eventData?.eventStatus) }}
            </div>
            <div class="status-skeleton" *ngIf="pageloading"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Metrics Section -->
    <div class="chart-layout-teacher">
      <div class="d-flex gap-3 flex-column w-100">
        <div class="d-flex justify-content-between gap-2 three-items-container">
          <div class="total-card" [class.total-card-active]="true">
            <span class="secondary-text" [class.skeleton-text]="pageloading"
              >Total registrations</span
            >
            <span class="primary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading ? "---" : engagementMetrics?.totalRegistrations || 0
              }}
            </span>
          </div>

          <div class="total-card">
            <span class="secondary-text" [class.skeleton-text]="pageloading"
              >Total attendees</span
            >
            <span class="primary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "---" : engagementMetrics?.totalAttendees || 0 }}
            </span>
          </div>

          <div class="total-card">
            <span class="secondary-text" [class.skeleton-text]="pageloading"
              >Conversion</span
            >
            <span class="primary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "---"
                  : (engagementMetrics?.conversionRate || 0) + "%"
              }}
            </span>
          </div>
        </div>

        <!-- Event Details Card -->
        <div class="chart-details-card d-grid gap-3">
          <div class="teacher-details">
            <div class="d-grid gap-2 align-items-start">
              <span class="primary-text" [class.skeleton-text]="pageloading"
                >Focus area :</span
              >
              <span class="secondary-text" [class.skeleton-text]="pageloading">
                {{ pageloading ? "Loading..." : getFocusAreaNames() }}
              </span>
            </div>
            <div class="d-grid gap-2 align-items-start">
              <span class="primary-text" [class.skeleton-text]="pageloading"
                >Audience :</span
              >
              <span class="secondary-text" [class.skeleton-text]="pageloading">
                {{
                  pageloading
                    ? "Loading..."
                    : eventData?.audienceTypeName || "-"
                }}
              </span>
            </div>
            <div class="d-grid gap-2 align-items-start">
              <span class="primary-text" [class.skeleton-text]="pageloading"
                >Region :</span
              >
              <span class="secondary-text" [class.skeleton-text]="pageloading">
                {{
                  pageloading
                    ? "Loading..."
                    : eventData?.eventHostRegionName || "-"
                }}
              </span>
            </div>
          </div>
          <div class="teacher-details">
            <div class="d-grid gap-2 align-items-start">
              <span class="primary-text" [class.skeleton-text]="pageloading"
                >Event managers :</span
              >
              <span class="secondary-text" [class.skeleton-text]="pageloading">
                {{ pageloading ? "Loading..." : getManagersNames() }}
              </span>
            </div>
            <div class="d-grid gap-2 align-items-start">
              <span class="primary-text" [class.skeleton-text]="pageloading"
                >Industry Partners :</span
              >
              <span class="secondary-text" [class.skeleton-text]="pageloading">
                {{ pageloading ? "Loading..." : getMCCpartnersNames() }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Students Table Section -->
    <div class="table-details">
      <div class="settings-bg">
        <div
          class="d-flex justify-content-between settings-bg-button flex-wrap"
        >
          <div class="segment-buttons">
            <div [class.skeleton-text]="pageloading">Students</div>
          </div>
          <div class="add-buttons" *ngIf="!eventData?.isDraft">
            <button
              class="export-csv-button"
              (click)="exportStudentsToCSV()"
              [disabled]="pageloading || !eventStudentList.length"
            >
              <img
                src="assets/images/download-icon.svg"
                alt="export"
                class="plus-icon"
                [class.skeleton-img]="pageloading"
              />
              <span [class.skeleton-text]="pageloading">Export</span>
            </button>
            <button
              *ngIf="canEditCurrentEvent()"
              (click)="openAssignStudentsDialog()"
              [disabled]="pageloading || studentTabelLoading"
            >
              <img
                src="assets/images/add-icon.svg"
                alt="plus"
                class="plus-icon"
                [class.skeleton-img]="pageloading"
              />
              <span [class.skeleton-text]="pageloading">Assign student</span>
            </button>
          </div>
        </div>

        <div class="table-page">
          <app-table
            [columns]="teacheStudentColumn"
            [data]="eventStudentList"
            [loading]="studentTabelLoading || pageloading"
            [eventStatus]="eventData?.eventStatus"
            (toggleChange)="onToggleChange($event)"
            (downloadClick)="onDownloadConsent($event)"
            (noteUpdate)="onNoteUpdate($event)"
            [useEventStatusLabels]="true"
            (statusLabelChange)="onStudentStatusChange($event)"
            (rowClick)="onView($event)"
          >
          </app-table>
        </div>
      </div>
    </div>
  </div>
</main>

<main *ngIf="loginRole === 'student' && !isFetchingStudentData">
  <div class="d-grid gap-3">
    <div
      class="d-flex justify-content-between align-items-center width-class w-100 flex-wrap gap-3"
    >
      <div
        class="d-flex gap-3 align-items-center"
        style="cursor: pointer"
        (click)="!isLoading && goBack()"
      >
        <img
          class="action-button"
          [class.skeleton-img]="isLoading"
          src="../../../../../assets/images/Buttons/arrow-left.svg"
          alt="left"
        />
        <div class="header-text m-0" [class.skeleton-text]="isLoading">
          Back to event list
        </div>
      </div>
    </div>

    <div class="student-event-card">
      <div class="d-flex gap-4 w-100">
        <div class="student-event-image-container">
          <img
            class="student-event-image"
            [class.skeleton-img]="isLoading"
            [src]="
              isLoading
                ? 'assets/images/placeholder-image.svg'
                : eventData?.eventTypeImage ||
                  'assets/images/placeholder-image.svg'
            "
            [alt]="eventData?.eventTypeName"
          />
        </div>

        <div class="w-100 d-grid gap-3 align-items-baseline" style="min-width: 0;">
          <div
            class="d-flex w-100 justify-content-between align-items-center flex-wrap gap-2"
          >
            <div class="d-flex gap-2 align-items-center flex-wrap">
              <span class="event-name" [class.skeleton-text]="isLoading">
                {{
                  isLoading
                    ? "Loading..."
                    : eventData?.eventName || "Event Name"
                }}
              </span>
            </div>

            <div class="d-flex gap-4 align-items-start">
              <div class="d-grid gap-2 status-text" *ngIf="!isLoading">
                Event status
                <div class="status-dropdown-container">
                  <div
                    class="status-display"
                    [ngClass]="getStatusClass(eventData?.eventStatus)"
                  >
                    {{ getStatusDisplayValue(eventData?.eventStatus) }}
                  </div>
                  <div class="status-skeleton" *ngIf="isLoading"></div>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="!isLoading && (eventData?.eventTypeImageDescription || eventData?.eventTypeDescription)"
            class="des-text"
          >
            {{ eventData?.eventTypeImageDescription || eventData?.eventTypeDescription }}
          </div>

          <div class="details-layout-teacher">
            <div class="d-grid gap-2">
              <div class="primary-text" [class.skeleton-text]="isLoading">
                Event type
              </div>
              <div class="secondary-text" [class.skeleton-text]="isLoading">
                {{ isLoading ? "Loading..." : eventData?.eventType || "-" }}
              </div>
            </div>
            <div class="d-grid gap-2">
              <div class="primary-text" [class.skeleton-text]="isLoading">
                Start date
              </div>
              <div class="secondary-text" [class.skeleton-text]="isLoading">
                {{
                  isLoading
                    ? "Loading..."
                    : (eventData?.eventStartDate | brisbaneDate: "dd-MM-yyyy") || "-"
                }}
              </div>
            </div>
            <div class="d-grid gap-2">
              <div class="primary-text" [class.skeleton-text]="isLoading">
                End date
              </div>
              <div class="secondary-text" [class.skeleton-text]="isLoading">
                {{
                  isLoading
                    ? "Loading..."
                    : (eventData?.eventEndDate | brisbaneDate: "dd-MM-yyyy") || "-"
                }}
              </div>
            </div>
          </div>

          <div class="details-layout-teacher">
            <div class="d-grid gap-2">
              <div class="primary-text" [class.skeleton-text]="isLoading">
                Time
              </div>
              <div class="secondary-text" [class.skeleton-text]="isLoading">
                {{ isLoading ? "Loading..." : eventData?.eventTime || "-" }}
              </div>
            </div>
            <div class="d-grid gap-2">
              <div class="primary-text" [class.skeleton-text]="isLoading">
                Location
              </div>
              <div class="secondary-text" [class.skeleton-text]="isLoading">
                {{ isLoading ? "Loading..." : eventData?.location || "-" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="d-flex w-100 align-items-center"
        *ngIf="loginRole === 'student'"
      >
        <button
          class="int-button"
          [class.interested-state]="
            eventData?.registrationStatus &&
            !eventData?.isRegistered &&
            !(
              eventSegment === 'admin' &&
              eventData?.registrationStatus === 'TeacherRejected'
            )
          "
          [class.unapproved-state]="
            eventSegment === 'admin' &&
            eventData?.registrationStatus === 'TeacherRejected' &&
            !eventData?.isRegistered
          "
          [disabled]="isRegistered || isLoading"
          (click)="registerInterest()"
        >
          <span [class.skeleton-text]="isLoading">
            {{
              isLoading
                ? "Registering..."
                : eventData?.isRegistered
                  ? "Already Registered"
                  : eventSegment === "admin" &&
                      eventData?.registrationStatus === "TeacherRejected"
                    ? "Unapproved"
                    : eventData?.registrationStatus
                      ? eventData.registrationStatus
                      : "Are you Interested?"
            }}
          </span>
        </button>
      </div>
    </div>
  </div>
</main>

<main *ngIf="isUnauthorised" class="unauthorised-main">
  <div class="unauthorised-container">
    <div class="unauthorised-box">
      <img
        src="assets/images/cross-icon.svg"
        class="unauthorised-icon"
        alt="Not authorised"
      />
      <div class="unauthorised-title">Access Denied</div>
      <div class="unauthorised-message">
        Sorry, You are not authorised to access this page.
      </div>
      <button class="unauthorised-back-btn" (click)="goBack()">Go Back</button>
    </div>
  </div>
</main>
